document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const header = document.querySelector(".custom-header");
  const triggers = document.querySelectorAll('[class*="custom-header__link-"]');
  const menus = document.querySelectorAll(
    '[class*="custom-header__mega-menu-"]'
  );
  const mobileMenu = document.querySelector(
    ".custom-header__mobile-menu-wrapper"
  );

  let activeIndex = null;
  let currentTrigger = null;
  let currentMenu = null;
  let hideTimeout = null;

  function adjustMegaMenuOffset(topOffset = 67, isMobile = false) {
    const announcementBar = document.querySelector(".custom-announcement-bar");
    const barRect = announcementBar?.getBoundingClientRect();
    const barVisibleHeight = barRect
      ? Math.max(0, barRect.height - Math.abs(barRect.top))
      : 0;
    const offset = topOffset + barVisibleHeight;

    if (isMobile) {
      if (mobileMenu) {
        mobileMenu.style.setProperty("--mobile-menu-top", `${offset}px`);
      }
    } else {
      document.documentElement.style.setProperty(
        "--mega-menu-top",
        `${offset}px`
      );
    }
  }

  adjustMegaMenuOffset(67);
  adjustMegaMenuOffset(60, true);

  window.addEventListener("resize", () => {
    adjustMegaMenuOffset(67);
    adjustMegaMenuOffset(60, true);
  });

  window.addEventListener("scroll", () => {
    adjustMegaMenuOffset(67);
    adjustMegaMenuOffset(60, true);
  });

function showMenu(index, trigger) {
  if (activeIndex === index) return;

  hideAll(); // Снимаем все активные классы

  const menu = document.querySelector(`.custom-header__mega-menu-${index}`);
  if (!menu) return;

  // 💡 Отложим добавление классов, чтобы Safari и Chrome не слепили hide/show в одну операцию
  requestAnimationFrame(() => {
    trigger.classList.add("active");
    menu.classList.add("active");
    document.body.classList.add("overlay");

    activeIndex = index;
    currentTrigger = trigger;
    currentMenu = menu;
  });
}


  function hideAll() {
    triggers.forEach((t) => t.classList.remove("active"));
    menus.forEach((m) => m.classList.remove("active"));
    body.classList.remove("overlay");

    activeIndex = null;
    currentTrigger = null;
    currentMenu = null;
  }

  function isCursorOutsideAll(e) {
    const related = e.relatedTarget;
    return !(
      related &&
      (header.contains(related) ||
        (currentMenu && currentMenu.contains(related)))
    );
  }

  triggers.forEach((trigger) => {
    const index = trigger.className.match(/custom-header__link-(\d+)/)?.[1];
    if (!index) return;

    trigger.addEventListener("mouseenter", () => {
      showMenu(index, trigger);
    });

    trigger.addEventListener("mouseleave", (e) => {
      if (isCursorOutsideAll(e)) {
        scheduleHide();
      }
    });
  });

  menus.forEach((menu) => {
    menu.addEventListener("mouseleave", (e) => {
      if (isCursorOutsideAll(e)) {
        scheduleHide();
      }
    });

    menu.addEventListener("mouseenter", () => {
      clearTimeout(hideTimeout);
    });
  });

  header.addEventListener("mouseleave", (e) => {
    if (isCursorOutsideAll(e)) {
      scheduleHide();
    }
  });

  function scheduleHide() {
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      const overHeader = header.matches(":hover");
      const overMenu = currentMenu && currentMenu.matches(":hover");
      if (!overHeader && !overMenu) {
        hideAll();
      }
    }, 30);
  }

  const headerContent = document.querySelector(".custom-header__content");
  const iconButton = document.querySelector(".custom-header__icon-menu");

  iconButton.addEventListener("click", () => {
    headerContent.classList.toggle("active");
    iconButton.classList.toggle("active");
    mobileMenu.classList.toggle("active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const menuLinks = document.querySelectorAll(
    '.custom-header__mobile-link[class*="mobile-link-"]'
  );
  const allMenus = document.querySelectorAll(
    ".custom-header__mobile-menu-list"
  );

  let activeMenu = null;

  menuLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const classList = Array.from(link.classList);
      const match = classList.find((cls) => cls.startsWith("mobile-link-"));
      if (!match) return;

      const index = match.replace("mobile-link-", "");
      const targetMenu = document.querySelector(`.mobile-menu-${index}`);
      if (!targetMenu) return;

      allMenus.forEach((menu) => menu.classList.remove("active"));

      targetMenu.classList.add("active");
      activeMenu = targetMenu;

      const backText = link.textContent.trim();
      const backBtn = targetMenu.querySelector(".back-link-text");
      if (backBtn) {
        backBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="#221F1C" stroke-opacity="0.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ${backText}`;
      }
    });
  });

  document.querySelectorAll(".back-link-text").forEach((backBtn) => {
    backBtn.addEventListener("click", () => {
      if (activeMenu) {
        activeMenu.classList.remove("active");
        activeMenu = null;
      }
    });
  });
});

function getAutoMarginLeft(containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const parentWidth = container.parentElement.clientWidth;
  const containerWidth = Math.min(container.clientWidth, 1440);
  const marginLeft = (parentWidth - containerWidth) / 2;

  console.log("Calculated margin-left:", marginLeft + "px");
  return marginLeft;
}

const marginLeft = getAutoMarginLeft(".custom-header__rows-wrapper");
